<template>
  <div class="footer-menu__contacts">
    <div class="footer-menu__phone">
      <a class="footer-menu__phone-link" :href="'tel:' + contactPhone">{{ contactPhone }}</a>
      <p class="footer-menu__text">{{ $t('footer_free_phone') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterPhone',
  data () {
    return {
      contactPhone: window.config?.contactPhone
    }
  }
}
</script>

<style scoped lang="sass">

.footer-menu__contacts
  display: flex
  align-items: baseline

  +mmax(768)
    margin-top: 40px

.footer-menu__phone-link
  font-weight: 500
  font-size: 18px
  color: $white-text-color
  transition: .2s

  &:hover
    color: darken($white-text-color, 15%)
    text-decoration: none

.footer-menu__text
  font-weight: 400
  font-size: 14px
  color: $placeholder-color
  margin: 5px 0 0 0

.footer-menu__subscribe-form
  +mmax(768)
    display: flex
    flex-direction: column
    align-items: center
</style>
